import React from "react";
import PropTypes from "prop-types";
import { Layout as Layer, Col } from "antd";
import Sidebar from "./sidebar";
import useWindowDimension from "hooks/use-window-dimensions";
import Navbar from "./navbar";
// import Footer from "layouts/main/footer";

const MainLayout = ({ children }) => {
  const [width] = useWindowDimension();

  return (
    <Layer style={{ minHeight: "100vh", maxHeight: "100vh" }}>
      {width > 1300 ? (
        <div
          style={{
            display: "flex",
          }}
        >
          <Sidebar style={{ flexShrink: 0 }} />
          <Col
            style={{
              background: "white",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "#E1E1E1",
                width: "1px",
                marginTop: 30,
                flexShrink: 0,
                marginBottom: 30,
                height: "95%",
              }}
            ></div>
          </Col>
          <Layer style={{ flexShrink: 0 }}>{children}</Layer>
        </div>
      ) : (
        <div>
          <Layer>
            <Navbar />
            {children}
          </Layer>
        </div>
      )}
    </Layer>
  );
};

MainLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default MainLayout;
